import React, { useEffect, useContext } from 'react';
import { store } from '../reducer';
import { useHistory, Switch, Route, useRouteMatch } from 'react-router-dom';
import Daily from './Daily/Daily';
import OperatorDaily from "../OperatorsCommissions/Daily/Daily"
import Monthly from './Monthly/Monthly';
import OperatorMonthly from "../OperatorsCommissions/Monthly/Monthly"
import Yearly from './Yearly/Yearly';
import Custom from './Custom/CustomCommission';

import OperatorYearly from "../OperatorsCommissions/Yearly/Yearly"
import { makeStyles } from '@material-ui/core/styles';
import useRules from "../../../../../hooks/useRules"
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridGap: theme.spacing(1),
    gridTemplateRows: '100px',
    '& > div': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
    },
  },
}));

const Commissions = () => {
  useTitle("گزارش پورسانت ها")
  const classes = useStyles();
  const parentUrl = `/protected/admin/reports/commissions`;
  const {
    state,
    dispatch,
    showMessage,
    showError,
    itemsCountPerPage,
  } = useContext(store);
  const history = useHistory();
  const [rules,hasRule,isAdmin] = useRules();
  const {
    location: { pathname },
  } = history;

  const handleDaily = () => {
    history.push(`${parentUrl}/daily`);
  };
  const handleMonthly = () => {
    history.push(`${parentUrl}/monthly`);
  };
  const handleYearly = () => {
    history.push(`${parentUrl}/yearly`);
  };

  useEffect(() => {
    pathname === parentUrl &&
      dispatch({
        type: 'CHANGE_TITLE_CATEGORY',
        payload: {
          title: 'گزارش پورسانت‌ها',
          category: 'گزارش پورسانت‌های واریزی از محل کارمزد شرکت',
        },
      });
  }, [pathname]);
  return (
    <Switch>
      <Route path={`${parentUrl}/daily`}>
        {hasRule('can_manage_operators') || hasRule('can_see_commissions')?<Daily />:<OperatorDaily />}
      </Route>
      <Route path={`${parentUrl}/monthly`}>
        {hasRule('can_manage_operators') || hasRule('can_see_commissions')?<Monthly />:<OperatorMonthly />}
      </Route>
      <Route path={`${parentUrl}/yearly`}>
        {hasRule('can_manage_operators') || hasRule('can_see_commissions')?<Yearly />:<OperatorYearly />}
      </Route>
      <Route path={`${parentUrl}/custom/:id`}>
        {hasRule('can_manage_operators') || hasRule('can_see_commissions')?<Custom />:''}
      </Route>
      <Route exact path={`${parentUrl}`}>
        <div className={classes.root}>
          {hasRule('reports_commissions_daily') && <div onClick={handleDaily} style={{ background: '#c5cae9' }}>
            گزارش روزانه
          </div>}
          {hasRule('reports_commissions_monthly') && <div onClick={handleMonthly} style={{ background: '#f0f4c3' }}>
            گزارش ماهیانه
          </div>}
          {hasRule('reports_commissions_yearly') && <div onClick={handleYearly} style={{ background: '#f8bbd0' }}>
            گزارش سالیانه
          </div>}
        </div>
      </Route>
    </Switch>
  );
};

export default React.memo(Commissions);
